<template>
	<svg
		width="21"
		height="17"
		viewBox="0 0 21 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<clipPath id="cloudClip">
				<path
					d="M9 0C5.68629 0 3 2.68629 3 6C3 6.16685 3.00683 6.33225 3.02024 6.4959C1.23627 7.33405 0 9.14685 0 11.25C0 14.1495 2.35051 16.5 5.25 16.5H16.5C18.9853 16.5 21 14.4853 21 12C21 10.3153 20.0744 8.84814 18.7058 8.07699C18.7349 7.88865 18.75 7.69592 18.75 7.5C18.75 5.42893 17.0711 3.75 15 3.75C14.8559 3.75 14.7135 3.75816 14.5733 3.77408C13.6893 1.56282 11.528 0 9 0Z"
				/>
			</clipPath>
		</defs>

		<!-- Static cloud shape -->
		<path
			d="M9 0C5.68629 0 3 2.68629 3 6C3 6.16685 3.00683 6.33225 3.02024 6.4959C1.23627 7.33405 0 9.14685 0 11.25C0 14.1495 2.35051 16.5 5.25 16.5H16.5C18.9853 16.5 21 14.4853 21 12C21 10.3153 20.0744 8.84814 18.7058 8.07699C18.7349 7.88865 18.75 7.69592 18.75 7.5C18.75 5.42893 17.0711 3.75 15 3.75C14.8559 3.75 14.7135 3.75816 14.5733 3.77408C13.6893 1.56282 11.528 0 9 0Z"
			fill="currentColor"
		/>

		<!-- Arrow clipped to cloud bounds, animating upward -->
		<g clip-path="url(#cloudClip)">
			<path
				class="arrow-sync"
				d="M11.0303 5.46967C10.7374 5.17678 10.2626 5.17678 9.96967 5.46967L6.96967 8.46967C6.67678 8.76256 6.67678 9.23744 6.96967 9.53033C7.26256 9.82322 7.73744 9.82322 8.03033 9.53033L9.75 7.81066L9.75 12.75C9.75 13.1642 10.0858 13.5 10.5 13.5C10.9142 13.5 11.25 13.1642 11.25 12.75V7.81066L12.9697 9.53033C13.2626 9.82322 13.7374 9.82322 14.0303 9.53033C14.3232 9.23744 14.3232 8.76256 14.0303 8.46967L11.0303 5.46967Z"
				fill="white"
			/>
		</g>
	</svg>
</template>

<style scoped>
@keyframes arrowSync {
	0% {
		transform: translateY(0px);
		opacity: 1;
	}
	40% {
		transform: translateY(-9px);
		opacity: 0;
	}
	41% {
		transform: translateY(9px);
		opacity: 0;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}
.arrow-sync {
	animation: arrowSync 1.4s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}
</style>
